import React from 'react';
import './home.scss';

export function Home() {
    return (
        <section className="home">
            <h1>Chase Schweitzer</h1>
            <span>Established Nineteen Ninety Six // Des Moines, IA</span>
        </section>
    );
}
